// @ts-nocheck
import React, { useState, useEffect } from 'react';

export default function QuickQuestion({ onExplore, onDesignBoard }) {
  const [answer, setAnswer] = useState('');
  const [mounted, setMounted] = useState(false);

  useEffect(() => { setMounted(true); }, []);

  const canDesign = answer.trim().length >= 5;

  return (
    <>
      <div style={styles.bg} />
      <div style={{ ...styles.container, opacity: mounted ? 1 : 0, transform: mounted ? 'translateY(0)' : 'translateY(20px)' }}>

        <div style={styles.logoSection}>
          <div style={styles.logoIcon}>🎲</div>
          <h1 style={styles.logoText}>Mokshapatra</h1>
        </div>

        <div style={styles.card}>
          <h2 style={styles.cardTitle}>What brings you here?</h2>
          <p style={styles.cardSubtitle}>Share as much or as little as you like — this shapes your journey</p>

          <textarea
            style={styles.textarea}
            value={answer}
            onChange={e => setAnswer(e.target.value)}
            placeholder="I'm here because..."
            rows={4}
          />

          <div style={styles.btnGroup}>
            <button
              style={{ ...styles.primaryBtn, opacity: canDesign ? 1 : 0.45, cursor: canDesign ? 'pointer' : 'default' }}
              onClick={() => canDesign && onDesignBoard(answer.trim())}
              disabled={!canDesign}
            >
              Design my personal board
            </button>

            <button
              style={styles.secondaryBtn}
              onClick={() => onExplore(answer.trim())}
            >
              Roll the dice &amp; explore
            </button>
          </div>

          <p style={styles.hint}>
            Designing your board personalizes the journey. You can always do it later.
          </p>
        </div>

        <p style={styles.quote}>"The journey of a thousand miles begins with a single step"</p>
      </div>

      <style>{`
        @keyframes float { 0%,100%{transform:translateY(0)} 50%{transform:translateY(-10px)} }
      `}</style>
    </>
  );
}

const styles = {
  bg: {
    position: 'fixed', inset: 0, background: '#0D0D2B', zIndex: -1,
  },
  container: {
    minHeight: '100vh', display: 'flex', flexDirection: 'column',
    alignItems: 'center', justifyContent: 'center',
    padding: '40px 20px', transition: 'all 0.6s ease',
  },
  logoSection: { textAlign: 'center', marginBottom: '36px' },
  logoIcon: { fontSize: '52px', marginBottom: '10px', display: 'block', animation: 'float 3s ease-in-out infinite' },
  logoText: {
    fontFamily: '"Cinzel", serif', fontSize: '32px', fontWeight: '700',
    color: '#C9920A', margin: 0, letterSpacing: '2px',
  },

  card: {
    background: '#1E1145', border: '1px solid rgba(201,146,10,0.25)',
    borderRadius: '20px', padding: '40px 32px',
    maxWidth: '460px', width: '100%',
    boxShadow: '0 20px 60px rgba(0,0,0,0.5)',
  },
  cardTitle: {
    fontFamily: '"Cinzel", serif', fontSize: '22px', fontWeight: '700',
    color: '#F5F0E8', marginBottom: '10px', textAlign: 'center', marginTop: 0,
  },
  cardSubtitle: {
    fontSize: '14px', color: 'rgba(245,240,232,0.55)',
    marginBottom: '24px', textAlign: 'center', lineHeight: '1.5',
  },

  textarea: {
    width: '100%', padding: '14px', fontSize: '15px',
    border: '1px solid rgba(201,146,10,0.25)', borderRadius: '12px',
    background: 'rgba(255,255,255,0.05)', color: '#F5F0E8',
    fontFamily: '"Lato", sans-serif', boxSizing: 'border-box',
    outline: 'none', resize: 'vertical', lineHeight: '1.6',
    marginBottom: '20px',
  },

  btnGroup: { display: 'flex', flexDirection: 'column', gap: '12px' },

  primaryBtn: {
    width: '100%', padding: '15px', background: '#C9920A',
    border: 'none', borderRadius: '12px', fontSize: '16px',
    fontWeight: '700', color: '#0D0D2B',
    fontFamily: '"Lato", sans-serif', transition: 'opacity 0.2s',
  },

  secondaryBtn: {
    width: '100%', padding: '14px', background: 'transparent',
    border: '2px solid rgba(201,146,10,0.5)', borderRadius: '12px',
    fontSize: '15px', fontWeight: '600', color: '#C9920A',
    fontFamily: '"Lato", sans-serif', cursor: 'pointer',
  },

  hint: {
    fontSize: '12px', color: 'rgba(245,240,232,0.35)',
    textAlign: 'center', marginTop: '18px', marginBottom: 0, lineHeight: '1.5',
  },

  quote: {
    marginTop: '28px', fontSize: '13px', color: 'rgba(245,240,232,0.35)',
    fontStyle: 'italic', textAlign: 'center',
  },
};
